module.exports = __webpack_public_path__ + "static/media/avatar9.93d578fa.png";